var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{staticStyle:{"width":"100%"},attrs:{"value":_vm.job.progress,"height":"20","rounded":""}},[_c('strong',[_vm._v(_vm._s(Math.ceil(_vm.job.progress))+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }